import * as React from "react";
import { SVGProps } from "react";
const SvgBattery = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 38" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.833 14H4.167V9h11.666v5Zm0 1.667H4.167v5h11.666v-5Zm0 13.333H4.167v5h11.666v-5Zm0-6.666H4.167v5h11.666v-5Zm3.334 11.025a3.975 3.975 0 0 1-3.967 3.975H4.833a3.975 3.975 0 0 1-4-3.975V6.692a1.042 1.042 0 0 1 1.042-1.025h2.292V2.592A1.925 1.925 0 0 1 6.092.667h7.816A2.008 2.008 0 0 1 15.833 2.7v2.967h2.25a1.042 1.042 0 0 1 1.084 1.042v26.65ZM5.833 5.667h8.334V2.7c0-.183-.167-.366-.259-.366H6.092a.258.258 0 0 0-.259.258v3.075ZM17.5 7.334h-15v26.025a2.308 2.308 0 0 0 2.333 2.308H15.2a2.309 2.309 0 0 0 2.3-2.308V7.334Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBattery;
